/**
 * @generated SignedSource<<d345a7faa8eb25ff2852dcc59647f7d5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResultBuyingCreditsOperation = "FAILED" | "SUCCESS" | "SUCCESS_FOR_TRIAL" | "WAITING_FOR_APPROVAL";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_SIDE_GENERATOR" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type ServiceRechargeCreditsInput = {
  autoRefill: boolean;
  credits: number;
  currencyCode: string;
  expirationDate?: string | null;
  isForTrial?: boolean | null;
  isForTrialOnFirstPackage?: boolean | null;
  returnUrlFromApproval?: string | null;
  service: ServicesWithCredits;
  shopifyChargeID?: string | null;
};
export type discoveryAiCreditsPurchaseDialogBuyMutation$variables = {
  input: ServiceRechargeCreditsInput;
};
export type discoveryAiCreditsPurchaseDialogBuyMutation$data = {
  readonly buyServiceCredits: {
    readonly errorMessage: string | null;
    readonly result: ResultBuyingCreditsOperation;
    readonly urlForApproval: string | null;
  } | null;
};
export type discoveryAiCreditsPurchaseDialogBuyMutation = {
  response: discoveryAiCreditsPurchaseDialogBuyMutation$data;
  variables: discoveryAiCreditsPurchaseDialogBuyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ServiceBuyingResultOperation",
    "kind": "LinkedField",
    "name": "buyServiceCredits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlForApproval",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "discoveryAiCreditsPurchaseDialogBuyMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "discoveryAiCreditsPurchaseDialogBuyMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "d996c61d4ab6b88af92e9f432e60c309",
    "id": null,
    "metadata": {},
    "name": "discoveryAiCreditsPurchaseDialogBuyMutation",
    "operationKind": "mutation",
    "text": "mutation discoveryAiCreditsPurchaseDialogBuyMutation(\n  $input: ServiceRechargeCreditsInput!\n) {\n  buyServiceCredits(input: $input) {\n    errorMessage\n    result\n    urlForApproval\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c5eb8e4c3a1f000009c6f4de3dd4e9f";

export default node;
